import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import glossaryIcon from '@/assets/glossary.svg';
import { PAGE_ROUTE_PATH } from '@/constants';

/**
 * プロパティ
 */
type Props = {
  /** メニューを閉じる */
  onCloseMenu: () => void;
};

/**
 * メインメニュー内の用語集ボタン。
 * クリックするとメニューを閉じて用語集画面へ遷移する。
 */
export const GlossaryContainer = React.memo(({ onCloseMenu }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    onCloseMenu();
    navigate(PAGE_ROUTE_PATH.GLOSSARY);
  };

  return (
    <button type="button" onClick={handleClick}>
      <img src={glossaryIcon} alt="glossary" />
      {t('mainMenu.用語集')}
    </button>
  );
});
